module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "full-height",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-tabs', {
    staticClass: "full-height",
    attrs: {
      "centered": "",
      "grow": ""
    }
  }, [_c('v-tabs-bar', {
    staticClass: "grey lighten-4",
    attrs: {
      "slot": "activators"
    },
    slot: "activators"
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "black primary"
    }
  }), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#tab-online"
    }
  }, [_c('v-icon', [_vm._v("people")])], 1), _vm._v(" "), (_vm.admin) ? _c('v-tabs-item', {
    staticClass: "black--text",
    attrs: {
      "href": "#tab-settings"
    }
  }, [_c('v-icon', [_vm._v("settings")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    staticClass: "full-height",
    attrs: {
      "id": "tab-online"
    }
  }, [_c('v-card', {
    staticClass: "full-height",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "full-height"
  }, [_vm._l((_vm.onlineUsers), function(user) {
    return _c('v-flex', {
      key: user.username,
      staticClass: "text-xs-left"
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('div', [_c('img', {
      staticClass: "pic",
      attrs: {
        "src": user.avatar.thumb.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bubble online"
    })]), _vm._v(" "), _c('div', {
      staticClass: "msg-name"
    }, [_c('user-modal', {
      attrs: {
        "user": user
      }
    })], 1)])], 1)
  }), _vm._v(" "), _vm._l((_vm.idleUsers), function(user) {
    return _c('v-flex', {
      key: user.username,
      staticClass: "text-xs-left"
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('div', [_c('img', {
      staticClass: "pic",
      attrs: {
        "src": user.avatar.thumb.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bubble idle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "msg-name"
    }, [_c('user-modal', {
      attrs: {
        "user": user
      }
    })], 1)])], 1)
  })], 2)], 1)], 1), _vm._v(" "), (_vm.admin) ? _c('v-tabs-content', {
    attrs: {
      "id": "tab-settings"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [(_vm.admin) ? [_c('v-switch', {
    attrs: {
      "label": "Enable links?"
    },
    model: {
      value: (_vm.room.settings.links),
      callback: function($$v) {
        _vm.$set(_vm.room.settings, "links", $$v)
      },
      expression: "room.settings.links"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Character limit?"
    },
    model: {
      value: (_vm.room.settings.charLimitBool),
      callback: function($$v) {
        _vm.$set(_vm.room.settings, "charLimitBool", $$v)
      },
      expression: "room.settings.charLimitBool"
    }
  }), _vm._v(" "), (_vm.room.settings.charLimitBool) ? _c('v-text-field', {
    attrs: {
      "label": "Limit",
      "placeholder": "# of characters",
      "rules": [_vm.rules.number]
    },
    model: {
      value: (_vm.room.settings.charLimit),
      callback: function($$v) {
        _vm.$set(_vm.room.settings, "charLimit", $$v)
      },
      expression: "room.settings.charLimit"
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), void 0], 2)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14df5028","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/chatsidebar.vue
// module id = 1619
// module chunks = 180